import type { ReactNode } from "react";
import { ListEmpty, ListLoading } from "@/components/list/status-text";

// Shared skeleton for task queues (inbox rows, per-entity task lists):
// loading & empty states plus the stacked-row container. Rows come from the
// caller and must carry their own keys.
export const ConfirmQueue = <T,>({
  items,
  isLoading,
  empty,
  renderRow,
}: {
  items: T[] | undefined;
  isLoading?: boolean;
  empty: string;
  renderRow: (item: T, index: number) => ReactNode;
}) => {
  if (!items?.length) {
    return isLoading ? <ListLoading /> : <ListEmpty>{empty}</ListEmpty>;
  }
  return (
    <div className="flex flex-col gap-1">
      {items.map((item, i) => renderRow(item, i))}
    </div>
  );
};
